export default "/images/074d849175f6d88d02c07cbc57b4ad4a.avif";